<template>
  <div class="d-none"></div>
</template>
<script>
export default {
  name: "TheMessages",
  computed: {
    isnew() {
      return this.$store.state.lastapimessage.isnew;
    }
  },
  watch: {
    isnew(newValue, oldValue) {
      if (oldValue === true && newValue === false) return;
      this.$bvToast.toast(this.$store.state.lastapimessage.message, {
        autoHideDelay: 4000,
        // noAutoHide: true,
        toaster: "b-toaster-top-center",
        appendToast: true,
        solid: true,
        variant: this.$store.state.lastapimessage.type
      });
      this.$store.commit("lastapimessage/displayed");
    }
  }
};
</script>